import type { ReactNode } from "react";
import { X } from "lucide-react";

type Props = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
};

export function FolderMobileSheet({ open, onClose, children }: Props) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-[1px]"
        aria-hidden
      />
      <aside className="mail-panel absolute inset-y-2 left-2 flex w-[min(100%,20rem)] flex-col overflow-hidden shadow-[var(--mail-shadow-md)] md:inset-y-3 md:left-3 md:w-80">
        <div className="flex shrink-0 items-center justify-between border-b border-[var(--mail-border-soft)] px-3 py-2">
          <p className="text-sm font-semibold">Dossiers</p>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md p-1.5 text-[var(--mail-muted)] hover:bg-[var(--mail-surface-hover)]"
            aria-label="Fermer"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
      </aside>
    </div>
  );
}
